import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Type, Brand } from "@models/interfaces";
import { BrandService } from "@shared/services/brand.service";
import { TypeService } from "@shared/services/type.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "mv-lists-description",
    styleUrls: ["./description.component.scss"],
    templateUrl: "./description.component.html",
})
export class DescriptionComponent implements OnInit {
    public brand: Brand;
    public type: Type;
    public longType: string = "";

    private readonly destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private brandService: BrandService,
        private typeService: TypeService,
        private titleService: Title,
    ) {}

    ngOnInit() {
        this.brandService.brand$.pipe(takeUntil(this.destroy$)).subscribe((brandVal) => {
            this.brand = brandVal;
        });

        this.typeService.type$.pipe(takeUntil(this.destroy$)).subscribe((typeVal) => {
            this.type = typeVal;
        });

        this.longType = this.titleService.getTitle();
    }
}
